import React , {Component} from 'react';




class About extends Component{
	
	
	
	
	render(){
		
		return(
		
			<h1> About</h1>
		
		);
		
		
	}
	
	
}

export default About;


// WEBPACK FOOTER //
// ./src/Components/About.jsx